import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import _ from 'lodash'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { RotatingLines } from "react-loader-spinner";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectCurrent } from "../../../../../redux/settings/selectors";
import useWindowDimensions from "../../../../../hooks/useWindowsDimensions";
import { selectOrganizationUnitsListItems } from "../../../../../redux/organizationUnits/selector";
import { selectLeadsCreatedItem } from "../../../../../redux/leads/selector";
import storePersist from "../../../../../redux/storePersist";
import { getCardData, getFunctionCardData } from "../../../../../common/services/website-card.service";
import { library } from "../../../../../redux/library/action";
import { countries } from "../../../../../redux/countries/action";
import { states } from "../../../../../redux/states/action";
import { cmsSettings } from "../../../../../redux/cmsSettings/action";
import { newsletterSubscriptions } from "../../../../../redux/news-letter-subscription/action";
import { leads } from "../../../../../redux/leads/action";
import { settings } from "../../../../../redux/settings/actions";
import GoogleMapSearch from "../../../../../common/components/google-map-search";
import { selectWebsiteCardsListItems } from "../../../../../redux/websiteCards/selector";
import { selectTermsLibrariesListItems } from "../../../../../redux/terms-libraries/selector";
import { termsLibraries } from "../../../../../redux/terms-libraries/action";


const LogisticHomeMobile = () => {
    const dispatch = useAppDispatch()
    let navigate = useNavigate()
    const result = useSelector(selectCurrent)
    const { tenantId, lightLogo, darkLogo } = result
    const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false)
    const [isLead, setIsLead] = useState<boolean>(false)
    const { height, width } = useWindowDimensions();
    const [color, setColor] = useState('universal')
    const [logo, setLogo] = useState<any>()
    const [socialIconData, setSocialIconData] = useState<any>();
    const [ouDetails, setOUDetails] = useState<any>();
    const organizationLists = useSelector(selectOrganizationUnitsListItems)
    const [generateIds, setGenerateIds] = useState<any>([]);
    const [leadValues, setLeadValues] = useState<any>()
    const leadCreateData = useSelector(selectLeadsCreatedItem)
    const [subscriptionData, getsubscriptionData] = useState<any>();
    const [searchedLocation, setSearchedLocation] = useState({
        name: '',
        lat: '',
        lng: '',
        pincode: '',
        description: '',
    });
    const termsLibraryListItems = useSelector(selectTermsLibrariesListItems)

    const [searchedToLocation, setSearchedToLocation] = useState({
        name: '',
        lat: '',
        lng: '',
        pincode: '',
        description: '',
    });
    const websiteCardsList = useSelector(selectWebsiteCardsListItems);
    const address = `${ouDetails?.PrimaryAddress?.Address1} , ${ouDetails?.PrimaryAddress?.Address2} , ${ouDetails?.PrimaryAddress?.City} - ${ouDetails?.PrimaryAddress?.ZipPostalCode},${ouDetails?.PrimaryAddress?.StateProvince?.Name},${ouDetails?.PrimaryAddress?.Country?.Name}.`;
    const phoneNumber = ouDetails?.OrganizationUnitInfo?.PhoneNumber
    const email = ouDetails?.OrganizationUnitInfo?.Email

    const handleChange: any = (event: any, field: string) => {
        setLeadValues({ ...leadValues, [field]: event })
        getsubscriptionData({ ...subscriptionData, [field]: event })
    }


    // Deferred API
    const deferredAPICalls = async () => {
        if (storePersist.get('guestTokenMetadata').current?.success) {
            await dispatch(library.read({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/library/query-by-list`, entity: 'library' }))
            await dispatch(countries.read({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/beta/countrys`, entity: 'countries' }))
            await dispatch(states.read({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/beta/stateprovinces`, entity: 'states' }))
            await dispatch(cmsSettings.list({ url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/cms/query`, entity: 'cmsSettings', jsonData: {} }))
        }

    }
    const getCardDetails = async () => {
        const footerSocialIconData: any = getCardData(websiteCardsList?.result?.items, 'LOGISTICS_QDP_FOOTER_SOCIALICON');
        setSocialIconData(footerSocialIconData)
        const ouDetails: any = getFunctionCardData(websiteCardsList?.result?.items, 'OU_DETAILS');
        setOUDetails(ouDetails)

    }



    useEffect(() => {
        setLogo(darkLogo || lightLogo)
    }, [result]);

    useEffect(() => {
        (async () => {
            getCardDetails()
            generateIdValue()
            dispatch(termsLibraries.list({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/contract/terms-libraries/list`, entity: 'termsLibraries', jsonData: {}
            }))
        })();
    }, []);

    const generateUniqueId = () => {
        const randomPart = Math.random().toString(36).substr(2, 9); // Random part
        const timestampPart = Date.now().toString(36); // Timestamp part
        return `${randomPart}-${timestampPart}`;
    };

    const generateIdValue = () => {
        const newItem = {
            transaction_id: generateUniqueId(),
            message_id: generateUniqueId(),
        };
        setGenerateIds(newItem);
    };



    useEffect(() => {
        (async () => {
            if (tenantId) {
                localStorage.removeItem('access-token')
                localStorage.removeItem('accessTokenMetadata')
                localStorage.removeItem('userProfile')
                deferredAPICalls();

            }
        })()
    }, [tenantId])


    const HomePageBannerData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'LOGISTICS_QDP_HOME_MAIN_PAGE_BANNER') : null;

    const banner = (HomePageBannerData && HomePageBannerData[0]?.src ? encodeURI(HomePageBannerData[0]?.src) : require('./../../../../../assets/img/logisticsBanner.png'))

    const workProcessHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'LOGISTICS_QDP_HOME_MAIN_PAGE_WORK_PROCESS_HEADING') : null;

    const workProcessData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'LOGISTICS_QDP_HOME_MAIN_PAGE_WORK_PROCESS') : null;

    const eMobilityHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'LOGISTICS_QDP_HOME_MAIN_PAGE_E_MOBILITY_HEADING') : null;

    const eMobilityData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'LOGISTICS_QDP_HOME_MAIN_PAGE_E_MOBILITY') : null;

    const serviceHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'LOGISTICS_QDP_HOME_MAIN_PAGE_SERVICE_HEADING') : null;

    const serviceData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'LOGISTICS_QDP_HOME_MAIN_PAGE_SERVICE') : null;

    const copyRightsContent: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ULIP_COPYRIGHTS') : null;

    const handleNavigate = (path: any) => {
        navigate(`${path}`)
    }
    const handlesubscriptionSubmit = async (event: any) => {
        event.preventDefault();
        dispatch(newsletterSubscriptions.create({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/news-letter-subscriptions`, entity: 'newsletterSubscriptions', jsonData:
            {
                "Records": [
                    {
                        "Email": subscriptionData?.Email,
                        "Active": true
                    }
                ]
            }
        })).then(() => {
            getsubscriptionData('')
            toast.success('Thanks for you interest. We will email you the coupon...')
        })
    }
    const handleSubmit = async (event: any) => {

        event?.preventDefault()
        if (!leadValues?.IsExistingUser) {
            if (
                !leadValues?.Email ||
                !leadValues?.Name ||
                !leadValues?.PhoneNumber ||
                !leadValues?.date ||
                !searchedLocation?.description ||
                !searchedToLocation?.description
            ) {
                toast.error("All fields are required. Please fill in all the details.");
                return;
            }
        } else {
            if (
                !leadValues?.date ||
                !leadValues?.Email ||
                !searchedLocation?.description ||
                !searchedToLocation?.description
            ) {
                toast.error("All fields are required. Please fill in all the details.");
                return;
            }
        }

        // Validate phone number length
        if (!leadValues?.IsExistingUser && leadValues?.PhoneNumber?.length < 10) {
            toast.error("Please enter a valid phone number with at least 10 digits.");
            return;
        }

        // Validate email format 
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (leadValues?.Email && !emailRegex.test(leadValues?.Email)) {
            toast.error("Please enter a valid email address.");
            return;
        }

        // Parse addresses
        const fromAddressData = _.split(searchedLocation?.description, ',');
        const toAddressData = _.split(searchedToLocation?.description, ',');
        try {
            await setIsButtonLoading(true)
            if (searchedLocation?.description !== searchedToLocation?.description) {
                await dispatch(leads.resetAction({ actionType: 'create' }))
                await dispatch(leads.create({
                    url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/leads`, entity: 'leadCreate', jsonData: {
                        "Records": [
                            {
                                Context: {
                                    transaction_id: generateIds?.transaction_id,
                                    message_id: generateIds?.message_id,
                                },
                                Message: {
                                    LeadInfo: {
                                        Name: leadValues?.Name,
                                        Email: leadValues?.Email,
                                        PhoneNumber: leadValues?.PhoneNumber || '',
                                        date: leadValues?.date,
                                        Description: '',
                                        IsExistingUser: leadValues?.IsExistingUser || false,
                                        LeadPayload: {
                                            weight: {
                                                unit: '',
                                                value: 0
                                            },
                                            dimensions: {
                                                length: {
                                                    unit: '',
                                                    value: 0
                                                },
                                                breadth: {
                                                    unit: '',
                                                    value: 0
                                                },
                                                height: {
                                                    unit: '',
                                                    value: 0
                                                }
                                            },
                                            category: '',
                                            value: {
                                                currency: 'INR',
                                                value: 0
                                            },
                                            dangerous_goods: false
                                        },
                                        start: {
                                            location: {
                                                gps: `${searchedLocation?.lat},${searchedLocation?.lng}`,
                                                address: {
                                                    name: searchedLocation?.name,
                                                    building: searchedLocation?.description,
                                                    locality: `${fromAddressData[0]},${fromAddressData[1]}`,
                                                    city: searchedLocation?.name,
                                                    state: fromAddressData[3],
                                                    country: 'India',
                                                    area_code: searchedLocation?.pincode,
                                                },
                                            },
                                            contact: {
                                                phone: leadValues?.PhoneNumber,
                                                email: leadValues?.Email,
                                            },
                                        },

                                        end: {
                                            location: {
                                                gps: `${searchedToLocation?.lat},${searchedToLocation?.lng}`,
                                                address: {
                                                    name: searchedToLocation?.name,
                                                    building: searchedToLocation?.description,
                                                    locality: `${toAddressData[0]},${toAddressData[1]}`,
                                                    city: searchedToLocation?.name,
                                                    state: toAddressData[3],
                                                    country: 'India',
                                                    area_code: searchedToLocation?.pincode,
                                                },
                                            },
                                        },
                                    }
                                }
                            }
                        ]
                    }
                }))
                await setIsButtonLoading(false)
                await setIsLead(true)
            }

            else {
                setIsButtonLoading(false)
                toast.error("The Pickup and Drop addresses must be different.")
            }

        } catch (error) {
            toast.error("An error occurred while submitting the form. Please try again.");
        }
    }

    useEffect(() => {
        if (leadCreateData?.isSuccess && isLead) {
            dispatch(settings.set({
                quoteData: leadValues,
                searchedLocation,
                searchedToLocation,
            }))
            setSearchedLocation({
                name: '',
                lat: '',
                lng: '',
                pincode: '',
                description: '',
            });
            setSearchedToLocation({
                name: '',
                lat: '',
                lng: '',
                pincode: '',
                description: '',
            });
            setLeadValues({
                Name: '',
                Email: '',
                PhoneNumber: '',
                date: '',
                IsExistingUser: '',
            })
            setIsLead(false)
            navigate('/auth/login', {
                state:
                    { pageName: 'Parcel' }
            })
        }
    }, [isLead])

    const HTMLContent: any = ({ htmlContent }: any) => {
        return (
            <div
                dangerouslySetInnerHTML={{ __html: htmlContent }}
            />
        );
    };

    return (
        <>

            <div className={`max-h-screen`}>
                <div className="h-full overflow-y-auto">
                    <div className="flex flex-col justify-around items-center w-screen h-max mt-20 px-5 " style={{
                        backgroundImage: `url(${banner})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat'
                    }}>

                        <div className={`w-full mt-32 justify-center item-center rounded-t-xl  bg-white `}>
                            <div className=" w-full p-1 flex flex-col justify-center items-center rounded-xl">
                                <div className="text-2xl text-primary font-bold py-5">Instant Quote Calculator</div>
                                <div className=" w-full px-3 font-bold space-y-2">
                                    <div className="flex flex-row ">
                                        <div className=" w-full text-xs flex flex-row justify-start items-center">
                                            <input
                                                type="checkbox"
                                                name={"from"}
                                                placeholder=""
                                                className={`px-2 teritary-${color} text-xs px-3`}
                                                onChange={(event) => {
                                                    handleChange(
                                                        event.target.checked,
                                                        'IsExistingUser'
                                                    )
                                                }}
                                                value={leadValues?.IsExistingUser}
                                            />
                                            <div className="mx-2">Are You Already Register?</div>
                                        </div>
                                    </div>
                                    {!leadValues?.IsExistingUser ? <>
                                        <div className="flex flex-row space-x-2 ">
                                            <div className=" w-full">
                                                {/* Name Input */}
                                                <div className="border-0 font-normal">
                                                    <input
                                                        required
                                                        type="text"
                                                        name="Name"
                                                        placeholder="Full Name"
                                                        className="w-full py-3 px-3 border-b-2 border-black text-base"
                                                        onChange={(event) => handleChange(event.target.value, 'Name')}
                                                        value={leadValues?.Name}
                                                    />
                                                </div>
                                            </div>

                                        </div>
                                        <div className="flex flex-row space-x-2 ">
                                            <div className=" w-full">
                                                {/* <label
															className="block text-xs font-bold mb-1"
															htmlFor="grid-password">
															Mobile
														</label> */}
                                                <div className="border-0 font-normal">
                                                    <input
                                                        required
                                                        maxLength={10}
                                                        type="text"
                                                        name={"PhoneNumber"}
                                                        placeholder="Phone Number"
                                                        pattern="\d{10}"
                                                        className={`w-full py-3 px-3 border-b-2 border-black text-base `}
                                                        onChange={(event) => {
                                                            handleChange(
                                                                event.target.value.replace(/\D/g, ''),
                                                                'PhoneNumber'
                                                            );
                                                        }}
                                                        value={leadValues?.PhoneNumber} />
                                                    {leadValues?.PhoneNumber && leadValues?.PhoneNumber?.length < 10 && (
                                                        <span className="text-red-600 text-xs">
                                                            Please enter a valid number.
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className=" w-full">
                                                {/* <label
															className="block text-xs font-bold mb-1"
															htmlFor="grid-password">
															Email
														</label> */}
                                                <div className="border-0   font-normal">
                                                    <input
                                                        required
                                                        type="email"
                                                        name={"Email"}
                                                        placeholder="Email"
                                                        className={`w-full py-3 px-3 border-b-2 border-black text-base`}
                                                        onChange={(event) => {
                                                            handleChange(
                                                                event.target.value,
                                                                'Email'
                                                            );

                                                        }}
                                                        value={leadValues?.Email} />
                                                </div>
                                            </div>

                                        </div>
                                        <div className="flex flex-row space-x-2 ">
                                            <div className=" w-full pt-2">
                                                {/* <label
															className="block text-xs font-bold mb-1"
															htmlFor="grid-password">
															From
														</label> */}
                                                <div className="font-normal ">
                                                    <GoogleMapSearch
                                                        setLocation={setSearchedLocation}
                                                        location={searchedLocation}
                                                        placeholder="Pickup Address"
                                                        required />

                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex flex-row space-x-2 ">
                                            <div className=" w-full pt-4 ">
                                                {/* <label
															className="block text-xs font-bold mb-1"
															htmlFor="grid-password">
															To
														</label> */}
                                                <div className=" font-normal ">
                                                    <GoogleMapSearch
                                                        setLocation={setSearchedToLocation}
                                                        location={searchedToLocation}
                                                        placeholder="Drop Address"
                                                        required />
                                                </div>
                                            </div>
                                        </div>



                                        <div className="flex flex-row space-x-2 ">
                                            <div className=" w-full">
                                                {/* Schedule Date Input */}
                                                <div className="border-0 font-normal">
                                                    <div className="relative w-full">
                                                        {/* Label Placeholder */}
                                                        <label
                                                            htmlFor="frodatem"
                                                            className={`absolute top-3 left-3 text-gray-400 pointer-events-none ${leadValues?.date ? 'hidden' : ''}`}
                                                        >
                                                            Schedule Date & Time
                                                        </label>
                                                        <input
                                                            required
                                                            id="frodatem"
                                                            type="datetime-local"
                                                            min={
                                                                new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000)
                                                                    .toISOString()
                                                                    .slice(0, 16)
                                                            }
                                                            name="frodatem"
                                                            onClick={(event) => {
                                                                const input = event.target as HTMLInputElement; // Type cast to HTMLInputElement
                                                                input.showPicker(); // Now you can call showPicker() safely
                                                            }}
                                                            className={`w-full py-3  border-b-2 border-black text-base ${!leadValues?.date ? 'text-transparent' : 'text-sky-950'}`}
                                                            onChange={(event) => handleChange(event.target.value, 'date')}
                                                            value={leadValues?.date}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </> :
                                        <>
                                            <div className="flex flex-row space-x-2">
                                                <div className=" w-full">
                                                    {/* <label
																className="block text-xs font-bold mb-1"
																htmlFor="grid-password">
																Login with Email or PhoneNumber
															</label> */}
                                                    <div className="border-0  font-normal">
                                                        <input
                                                            required
                                                            type="text"
                                                            name={"Email"}
                                                            placeholder="Login with Email"
                                                            className={`w-full py-3 px-3 border-b-2 border-black text-base`}
                                                            onChange={(event) => {
                                                                handleChange(
                                                                    event.target.value,
                                                                    'Email'
                                                                );
                                                            }}
                                                            value={leadValues?.Email} />
                                                    </div>
                                                </div>

                                            </div><div className="flex flex-row space-x-2 ">
                                                <div className=" w-full pt-2">
                                                    {/* <label
																className="block text-xs font-bold mb-1"
																htmlFor="grid-password">
																From
															</label> */}
                                                    <div className="font-normal ">
                                                        <GoogleMapSearch
                                                            setLocation={setSearchedLocation}
                                                            location={searchedLocation}
                                                            placeholder="Pickup Address"
                                                            required />
                                                    </div>
                                                </div>
                                            </div><div className="flex flex-row space-x-2 ">
                                                <div className="w-full">
                                                    {/* <label
																className="block text-xs font-bold mb-1"
																htmlFor="grid-password">
																To
															</label> */}
                                                    <div className="font-normal pt-4 ">
                                                        <GoogleMapSearch
                                                            setLocation={setSearchedToLocation}
                                                            location={searchedToLocation}
                                                            placeholder="Drop Address"
                                                            required />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex flex-row space-x-2">
                                                <div className=" w-full">
                                                    {/* <label
																className="block text-xs font-bold mb-1"
																htmlFor="grid-password">
																Schedule Date
															</label> */}
                                                    <div className="font-normal ">
                                                        <div className="relative w-full">
                                                            {/* Label Placeholder */}
                                                            <label
                                                                htmlFor="frodatem"
                                                                className={`absolute top-3 left-2 text-gray-400 pointer-events-none ${leadValues?.date ? 'hidden' : ''
                                                                    }`}
                                                            >
                                                                Schedule Date & Time
                                                            </label>

                                                            <input
                                                                required
                                                                id="frodatem"
                                                                type="datetime-local"
                                                                min={
                                                                    new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000)
                                                                        .toISOString()
                                                                        .slice(0, 16)
                                                                }
                                                                name="frodatem"
                                                                onClick={(event) => {
                                                                    const input = event.target as HTMLInputElement; // Type cast to HTMLInputElement
                                                                    input.showPicker(); // Now you can call showPicker() safely
                                                                }}
                                                                className={`w-full py-3 px-3 border-b-2 border-black text-base ${!leadValues?.date ? 'text-transparent' : 'text-sky-950'
                                                                    }`}
                                                                onChange={(event) => handleChange(event.target.value, 'date')}
                                                                value={leadValues?.date}

                                                            />
                                                        </div>

                                                    </div>
                                                </div>
                                            </div></>
                                    }

                                </div>


                                <div className={`${isButtonLoading ? 'bg-primary bg-opacity-70' : 'bg-primary'} px-3 flex w-full flex-row flex item-center justify-center mt-5 mb-3 `}>
                                    <div
                                        onClick={handleSubmit}

                                        className=" flex-row flex items-center justify-center text-light text-base my-3 font-bold cursor-pointer"
                                    >
                                        Get Quote
                                        <div className={`pl-2 ${isButtonLoading ? 'visible' : 'invisible'}`}>
                                            <RotatingLines
                                                visible={true}
                                                width={'20'}
                                                strokeColor="#fff"
                                                strokeWidth="6"
                                                animationDuration="0.75"
                                                ariaLabel="rotating-lines-loading"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                    <div className="w-full bg-white  flex items-center justify-center flex-col h-max ">

                        {/* Section 1 */}
                        <div className={`flex flex-col justify-center items-center w-full pt-10 `}>
                            <div className="flex flex-col justify-start items-start px-2 w-full ">
                                <div className="font-bold text-2xl uppercase ">{workProcessHeading ? workProcessHeading[0]?.title : null}</div>
                            </div>
                            <div className="w-screen px-3 overflow-auto scrollbar-hide">
                                <div className="flex flex-row w-max justify-center item-center space-x-5 my-5">
                                    {/* Card 1 */}
                                    <div className="w-[200px] flex flex-col h-max items-center justify-center py-3">
                                        <div className="relative overflow-hidden bg-clip-border object-contain rounded-xl h-44">
                                            <img
                                                src={workProcessData && workProcessData[0].src ? workProcessData[0]?.src : 'https://via.placeholder.com/272x256'}
                                                alt="card-image"
                                                className="object-cover w-full h-full"
                                            />
                                        </div>
                                        <div className="font-semibold text-lg text-center mt-2">
                                            {workProcessData ? workProcessData[0]?.title : null}
                                        </div>
                                        <div className="text-center text-base mt-1">
                                            {workProcessData ? workProcessData[0]?.subTitle : null}
                                        </div>
                                    </div>
                                    {/* Card 2 */}
                                    <div className="w-[200px] flex flex-col h-max items-center justify-center py-3">
                                        <div className="relative overflow-hidden bg-clip-border object-contain rounded-xl h-44">
                                            <img
                                                src={workProcessData && workProcessData[1].src ? workProcessData[1]?.src : 'https://via.placeholder.com/272x256'}
                                                alt="card-image"
                                                className="object-cover w-full h-full"
                                            />
                                        </div>
                                        <div className="font-semibold text-lg text-center mt-2">
                                            {workProcessData ? workProcessData[1]?.title : null}
                                        </div>
                                        <div className="text-center text-base mt-1">
                                            {workProcessData ? workProcessData[1]?.subTitle : null}
                                        </div>
                                    </div>
                                    {/* Card 3 */}
                                    <div className="w-[200px] flex flex-col h-max items-center justify-center py-3">
                                        <div className="relative overflow-hidden bg-clip-border object-contain rounded-xl h-44">
                                            <img
                                                src={workProcessData && workProcessData[2].src ? workProcessData[2]?.src : 'https://via.placeholder.com/272x256'}
                                                alt="card-image"
                                                className="object-cover w-full h-full"
                                            />
                                        </div>
                                        <div className="font-semibold text-lg text-center mt-2">
                                            {workProcessData ? workProcessData[2]?.title : null}
                                        </div>
                                        <div className="text-center text-base mt-1">
                                            {workProcessData ? workProcessData[2]?.subTitle : null}
                                        </div>
                                    </div>
                                    {/* Card 4 */}
                                    <div className="w-[200px] flex flex-col h-max items-center justify-center py-3">
                                        <div className="relative overflow-hidden bg-clip-border object-contain rounded-xl h-44">
                                            <img
                                                src={workProcessData && workProcessData[3].src ? workProcessData[3]?.src : 'https://via.placeholder.com/272x256'}
                                                alt="card-image"
                                                className="object-cover w-full h-full"
                                            />
                                        </div>
                                        <div className="font-semibold text-lg text-center mt-2">
                                            {workProcessData ? workProcessData[3]?.title : null}
                                        </div>
                                        <div className="text-center text-base mt-1">
                                            {workProcessData ? workProcessData[3]?.subTitle : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Section 2 */}
                        <div className={`flex flex-col justify-center items-center w-full my-10 secondary-darkmode`}>
                            <div className="flex flex-col justify-start items-start px-4 w-full">
                                <div className="font-bold text-2xl uppercase">{eMobilityHeading ? eMobilityHeading[0]?.title : null}</div>
                            </div>
                            <div className="flex flex-row jjustify-center items-center space-x-5 my-5 w-full px-5">
                                {/* Card 1 */}
                                <div className={`w-[180px]  flex flex-col h-[210px] items-center justify-center py-3 bg-primary text-light shadow-xl rounded-xl`}>
                                    <div className="w-full flex items-center justify-center">
                                        <HTMLContent htmlContent={eMobilityData ? eMobilityData[0]?.description : ''} />
                                    </div>
                                    <div className="w-[150px] font-semibold  text-xl text-center  px-3 py-3 ">{eMobilityData ? eMobilityData[0]?.title : null}</div>
                                </div>
                                {/* Card 2 */}
                                <div className={`w-[180px] flex flex-col items-center  h-[210px] justify-center py-3  bg-primary text-light  shadow-xl rounded-xl`}>
                                    <div className="w-full flex items-center justify-center">
                                        <HTMLContent htmlContent={eMobilityData ? eMobilityData[1]?.description : ''} />
                                    </div>
                                    <div className="w-[150px] font-semibold text-xl text-center  px-3 py-3 ">{eMobilityData ? eMobilityData[1]?.title : null}</div>
                                </div>
                            </div>
                            <div className="flex flex-row justify-start item-start space-x-5 my-5  w-full px-5">
                                <div className={`w-[180px]  flex flex-col h-[210px] items-center justify-center py-3  bg-primary text-light shadow-xl rounded-xl`}>
                                    <div className="w-full flex items-center justify-center">
                                        <HTMLContent htmlContent={eMobilityData ? eMobilityData[2]?.description : ''} />
                                    </div>
                                    <div className="w-[150px] font-semibold text-xl text-center px-3 py-3 ">{eMobilityData ? eMobilityData[2]?.title : null}</div>
                                </div>
                                <div className={`w-[180px]  h-[210px] flex flex-col items-center justify-center py-3  bg-primary text-light  shadow-xl rounded-xl`}>
                                    <div className="w-full flex justify-center items-center p-2">
                                        <HTMLContent htmlContent={eMobilityData ? eMobilityData[3]?.description : ''} />
                                    </div>
                                    <div className="font-semibold text-xl text-center  px-3 py-3 ">{eMobilityData ? eMobilityData[3]?.title : null}</div>
                                </div>
                            </div>
                        </div>

                        {/* section 3 */}
                        <div className={`flex flex-col justify-center items-center w-full my-10 pb-10  secondary-darkmode`}>
                            <div className="flex flex-col justify-start items-start px-4 w-full">
                                <div className="font-bold text-2xl uppercase ">{serviceHeading ? serviceHeading[0]?.title : null}</div>
                            </div>
                            <div className="flex flex-col justify-center item-center space-y-5 my-5">
                                {/* Card 1 */}
                                <div className={`w-[250px]  flex flex-col h-max items-center justify-center space-y-4 py-3`}>
                                    <div>
                                        <HTMLContent htmlContent={serviceData ? serviceData[0]?.description : ''} />
                                    </div>
                                    <div className="w-[200px] font-semibold text-xl text-center px-3 py-3 ">{serviceData ? serviceData[0]?.title : null} </div>
                                    <div className="w-[250px] text-md main text-center px-3 rounded min-h-12">{serviceData ? serviceData[0]?.subTitle : null}</div>
                                </div>
                                {/* Card 2 */}
                                <div className={`w-[250px]  flex flex-col h-max items-center justify-center space-y-4 py-3`}>
                                    <div>
                                        <HTMLContent htmlContent={serviceData ? serviceData[1]?.description : ''} />
                                    </div>
                                    <div className="w-[200px] font-semibold text-xl text-center px-3 py-3 ">	{serviceData ? serviceData[1]?.title : null}</div>
                                    <div className="w-[250px] text-md main text-center px-3 rounded min-h-12">{serviceData ? serviceData[1]?.subTitle : null}</div>
                                </div>
                                {/* Card 3 */}
                                <div className={`w-[250px]  flex flex-col h-max items-center justify-center space-y-4 py-3`}>
                                    <div>
                                        <HTMLContent htmlContent={serviceData ? serviceData[2]?.description : ''} />
                                    </div>
                                    <div className="w-[200px] font-semibold text-xl text-center px-3 py-3 ">{serviceData ? serviceData[2]?.title : null}</div>
                                    <div className="w-[250px] text-md main text-center px-3 rounded min-h-12">{serviceData ? serviceData[2]?.subTitle : null}</div>
                                </div>

                            </div>
                        </div>


                    </div>
                </div>

            </div >


        </>
    )
}

export default LogisticHomeMobile
